export default "__VITE_ASSET__04f64ba6__"